import { useState } from 'react';
import {
  Box,
  Stack,
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import { SettingsPageHeader } from '../components';
import { DefaultDataEditor } from './DefaultDataEditor';

const IntegrationSettings = () => {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ position: "relative", height: "100%", width: "100%", overflow: "hidden" }}>
      <Box sx={{ height: "100%", width: "100%", overflow: "auto", p: 3, pb: 10 }}>
        <Stack spacing={4} sx={{ width: "100%" }}>
          <SettingsPageHeader title="Integration Settings" isDirty={false} />

          <Card variant="outlined">
            <CardContent>
              <Stack spacing={3}>
                <Typography variant="h6">Default Encounter Values</Typography>

                <Tabs value={activeTab} onChange={handleTabChange}>
                  <Tab label="Regular Encounters" disabled />
                  <Tab label="Expected Encounters" />
                </Tabs>

                {activeTab === 0 && (
                  <DefaultDataEditor
                    settingsPath="integration.defaultData"
                    helperText="Set default values for regular encounter outbound integration."
                  />
                )}

                {activeTab === 1 && (
                  <DefaultDataEditor
                    settingsPath="integration.expects.defaultData"
                    helperText="Set default values for expected encounter outbound integration."
                  />
                )}
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Box>
  );
};

export { IntegrationSettings };
